export const shortcutLinksWidget = async (err) => {
  if (err) {
    console.error(err);
  }

  const infosButton = document.querySelector(
    '.shortcut-links .wp-block-group:last-child a',
  );

  if (infosButton && window.innerWidth > 480) {
    let shortcutLinksContainer = document.querySelector('.shortcut-links');
    setTimeout(() => {
      window.onscroll = function () {
        shortcutLinksContainer.classList.add('closed-state');
      };
    }, 600);

    infosButton.addEventListener('click', (event) => {
      if (shortcutLinksContainer.classList.contains('closed-state')) {
        shortcutLinksContainer.classList.remove('closed-state');
      } else {
        shortcutLinksContainer.classList.add('closed-state');
      }

      event.preventDefault();
      event.stopPropagation();
    });
  }
};

import.meta.webpackHot?.accept(shortcutLinksWidget);
